<template>
	<div class="page-header">
		<p class="page-header__breadcrumb">{{ getBreadcrumb }}</p>
		<slot />
	</div>
</template>
<script>
	export default {
		name: 'PageHeader',
		props: {
			title: {
				type: String,
				default: '',
			},
		},
		computed: {
			getBreadcrumb() {
				const params = this.$route.params;
				const title = this.title || params.heading;
				return `${params.parentName ? `${params.parentName} > ` : ''}${title}`;
			},
		},
	};
</script>
<style lang="scss" scoped>
	DIV.page-header {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		margin-bottom: 18px;
		padding-bottom: 8px;
		border-bottom: solid 1px #222;

		.page-header__breadcrumb {
			font-size: 1.625rem;
		}
	}
</style>
